var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffer4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_896_32013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.40465 26.9953C8.485 26.9588 7.73258 26.7071 7.14426 26.2397C7.03198 26.1504 6.76443 25.8827 6.67467 25.7698C6.43609 25.4698 6.2739 25.1779 6.16571 24.854C5.83281 23.8568 6.00414 22.5484 6.65577 21.1124C7.2137 19.883 8.07462 18.6636 9.57661 16.9749C9.79786 16.7264 10.4567 15.9996 10.461 15.9996C10.4626 15.9996 10.4267 16.0618 10.3815 16.1376C9.99093 16.7917 9.65676 17.5623 9.47472 18.2293C9.18229 19.2997 9.21757 20.2182 9.57803 20.9305C9.82668 21.4212 10.253 21.8462 10.7323 22.0811C11.5715 22.4923 12.8001 22.5263 14.3005 22.1807C14.4038 22.1567 19.5227 20.7979 25.6759 19.1609C31.829 17.5238 36.8643 16.1855 36.8651 16.1866C36.8668 16.188 22.5695 22.3059 15.1476 25.4798C13.9722 25.9823 13.6579 26.1092 13.1053 26.3032C11.6928 26.7992 10.4274 27.0359 9.40465 26.9953Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_896_32013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.8651,
    height: 11,
    fill: "white",
    transform: "translate(6 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer4);
export default __webpack_public_path__ + "static/media/offer_4.3c97f0365d56af4f8ab9f32e9b1fe6ae.svg";
export { ForwardRef as ReactComponent };